export default "__VITE_ASSET__Dgi4pCgY__"